module.exports = __webpack_public_path__ + "marriot-card-bottom-left.sBCX9Aqa.png";